export default __webpack_public_path__ + "static/media/planting.5caf518c.svg";